var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgViewPt1 = function SvgViewPt1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.5 6.5h7m-5 3h3M2.797.5h10.406c1.368 0 2.297.929 2.297 2.297v10.406c0 1.368-.929 2.297-2.297 2.297H2.797C1.429 15.5.5 14.571.5 13.203V2.797C.5 1.429 1.429.5 2.797.5"
  })));
};
export { SvgViewPt1 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNNC41IDYuNWg3bS01IDNoM00yLjc5Ny41aDEwLjQwNmMxLjM2OCAwIDIuMjk3LjkyOSAyLjI5NyAyLjI5N3YxMC40MDZjMCAxLjM2OC0uOTI5IDIuMjk3LTIuMjk3IDIuMjk3SDIuNzk3QzEuNDI5IDE1LjUuNSAxNC41NzEuNSAxMy4yMDNWMi43OTdDLjUgMS40MjkgMS40MjkuNSAyLjc5Ny41Ii8+PC9zdmc+Cg==";